import { CHECK_OAUTH_LOGIN } from "./actions";

const initialState = {
  loading: false,
  status: "",
  msg: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_OAUTH_LOGIN.REQUEST:
      return { ...initialState, loading: true };
    case CHECK_OAUTH_LOGIN.SUCCESS:
      return { ...initialState, loading: false, status: "success" };
    case CHECK_OAUTH_LOGIN.FAILURE: {
      const { payload: { status, msg } } = action;
      return { ...initialState, loading: false, status, msg };
    }
    default:
      return state;
  }
};
